import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { SwGridTableComponent } from 'src/app/librarys/components/basic-components/sw-table/sw-grid-table/sw-grid-table.component';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from '../../../../kms.service';
declare var $;
@Component({
  selector: 'app-related-instance-select',
  templateUrl: './related-instance-select.component.html',
  styleUrls: ['./related-instance-select.component.css']
})
export class RelatedInstanceSelectComponent implements OnInit {
  @ViewChild('modal') modal: SwModalframeComponent;    //弹出层组件
  @Input() param:any;
  @Output() callback = new EventEmitter(); //抛出事件
  // 当前选中的tabid
  currentTab = 'select';
  // 数据绑定对象
  instanceModel: any = {}; 
  // 提交按钮是否禁用
  clickEnable = true; 
  // 表格对象
  @ViewChild("swtable") swtable: SwGridTableComponent;   
  // 搜索数据内容
  searchDatas = {
      instanceName: '',  // 实体名称
      conceptId: '',  // 所属概念id
  }
  // 实体表格数据
  datas:any = [];
  // 表格是否显示加载中
  isLoading: boolean = false;
  // 表格分页组件
  pageBase: any = { orderBy: null }
  // 表格中选中的数据
  selectedDatas:any = [];
  // 选中的实体信息
  selectedInstance:any = [];
  // 概念树数据
  conceptTreeData:any = [];
  // 默认不可选中的父级概念结点
  readonlySelfIds = [];
  constructor(
    private box: SwMassageBoxService,  //消息提示框
    private kmsService: KmsService,   //请求服务
  ) { }

  ngOnInit() {
    // 查询概念树
    this.getConceptTreeData();
    // 查询表格数据
    this.handleSelectClick();
  }

  // tab切换
  handleTabClick(id){
    this.currentTab = id;
  }

  // enter键触发搜索
  enterSearch(event) {
    if (event.keyCode == '13') {
        this.handleSelectClick();
    }
  }

  // 查询按钮方法
  handleSelectClick() {
    this.pageBase = {
      current: 1,
      size: 10
    };
    this.getData();
  }

  //获取数据
  getData() {
    this.isLoading = true;
    const params = {
      'instanceName': $.trim(this.searchDatas.instanceName),
      'conceptId': this.searchDatas.conceptId,
      'current': this.pageBase.current,
      'size': this.pageBase.size
    }
    this.kmsService.getInstanceQueryList(params).subscribe(
        result => {
            if (result.code == 200) {
                this.isLoading = false;
                this.pageBase = result.data;
                this.datas = result.data.records;
            } else {
                this.box.waring(result.msg);
            }
        }
    );
  }

  // 表格选中数据
  handleSelectData(event) {
    this.selectedDatas = event;
  }

  // 表格分页切换方法
  handlePageClick(event) {
    this.pageBase = event;
    this.getData();
  }

  // 重置按钮事件方法
  handleReloadClick() {
    this.searchDatas = {
        instanceName: '',  
        conceptId: '', 
    }
    this.pageBase = {
      current: 1,
      size: 10
    };
    this.getData();
  }

  // 选择实体
  select(){
    this.selectedDatas.forEach(item => {
      let len = this.selectedInstance.filter(item1 => item1.instanceId == item.instanceId).length;
      if(len == 0){
        this.selectedInstance.push(item);
      }
    })
  }

  // 删除选中的实体
  deleteFile(i){
    let arr = JSON.parse(JSON.stringify(this.selectedInstance))
    arr.splice(i,1)
    this.selectedInstance = arr
  }

  // 保存选中项
  saveSelections(){
    let list = [];
    this.selectedInstance.forEach(element => {
      let item = {
        "imageMarkId": this.param.imageMarkId,
        "instanceId": element.instanceId
      }
      list.push(item);
    });
    this.kmsService.batchSaveMarkShip(list).subscribe(
      data => {
        if (data.code == '200') {
            this.box.success('保存成功！');
            this.modal.toggle();
            this.callback.emit(true);
        } else {
            this.box.waring(data.msg);
        }
      }
    )
  }

  // 保存新增的实体信息
  onSubmit({ value, valid }, event: Event) {
    if (valid) {
      // let params:any = {
      //   instanceName: this.instanceModel.instanceName
      // };
      // if(this.instanceModel.conceptId){
      //   params.conceptId = this.instanceModel.conceptId;
      //   params.conceptCode = this.instanceModel.conceptCode;
      //   params.conceptName = this.instanceModel.conceptName;
      //   params.mapping = this.instanceModel.mapping;
      //   params.approvalStatus = 2;
      // }
      // this.kmsService.saveInstanceOneUpdate(params).subscribe(
      //   data => {
      //     if(data.code == '200'){
      //       // 增量更新索引
      //       this.updateIndex(data.data.instanceId);
            
      //       let list = [{
      //         "imageMarkId": this.param.imageMarkId,
      //         "instanceId": data.data.instanceId
      //       }]
      //       this.kmsService.batchSaveMarkShip(list).subscribe(
      //         res => {
      //           if (res.code == '200') {
      //               this.box.success('保存成功！');
      //               this.modal.toggle();
      //               this.callback.emit(true);
      //           } else {
      //               this.box.waring(data.msg);
      //           }
      //         }
      //       )
      //     }else{
      //       this.box.waring(data.msg);
      //     }
      //   }
      // )
    }
  }

  // 增量更新索引
  updateIndex(instanceId){
    this.kmsService.updateIndexByInstanceId(instanceId).subscribe(
        data => {
            if(data.code != '200'){
              console.log('索引更新失败!');
            }
        }
    )
  }

  // 查询概念树数据
  getConceptTreeData(){
    this.kmsService.getConceptTreeData({}).subscribe(
        data => {
            if (data.code == 200) {
                if (!data.data) {
                this.conceptTreeData = [];
                }
                this.conceptTreeData = data.data;
                this.readonlySelfIds = ['0'];
                this.conceptTreeData.forEach(item => {
                    if(this.conceptTreeData.filter(item1 => item1.pid == item.id).length > 0){
                        this.readonlySelfIds.push(item.id);
                    }
                });
            }
        }
    );
  }

  // 切换概念
  conceptChange(event){
    this.instanceModel.conceptId = event.id;
    this.instanceModel.conceptName = event.text;
    let item = this.conceptTreeData.filter(item => item.id == event.id)[0];
    this.instanceModel.conceptCode = item.code;
    this.instanceModel.mapping = item.mapping;
  }

  // 清除概念
  clearConcept(event){
    this.instanceModel.conceptId = '';
    this.instanceModel.conceptName = '';
    this.instanceModel.conceptCode = '';
    this.instanceModel.mapping = '';
  }
}

